export const DEPLOYMENT_FIX_WITH_AI_CONTRACT_ID = 'deployment_fix_with_ai_v2';

export const DEPLOYMENT_FIX_WITH_AI_PROMPT =
  'Fix this bot with AI. Inspect authoritative deployment status, the relevant run and logs, and the exact saved code. Diagnose the root cause and complete every safe recovery step now. If strategy code caused the failure, save and read back a corrected revision, then prepare an owner approval to update this same active or scheduled deployment, or to start it if it is stopped. Do not stop after explaining the error. Do not create a second deployment, change trading rules, guess a broker connection, or claim the fix is running before owner approval and a successful run.';

export const DEPLOYMENT_FIX_WITH_AI_PROMPT_SHA256 =
  '71c91ebb626066746c9e43325c82b5aae5b161c52f521ad3faa505b56aba7ba4';

export const DEPLOYMENT_FIX_WITH_AI_SOURCE = 'bot-details-schedule-fix';

type DeploymentRecoveryContextInput = {
  deploymentId: string | null;
  runId: string | null;
  status: string | null;
  healthCategory: string | null;
  healthReason: string | null;
  error: string | null;
};

type DeploymentFixWithAiHandoffInput = DeploymentRecoveryContextInput & {
  botId?: string | null;
  botName?: string | null;
};

export function buildDeploymentFixWithAiContext(input: DeploymentRecoveryContextInput) {
  return {
    externalEvent: {
      externalKind: 'deployment',
      eventName: 'deployment.status_changed',
      status: 'failed',
      previousStatus: input.status,
      isTerminal: true,
      externalId: input.deploymentId,
      payload: {
        deploymentId: input.deploymentId,
        runId: input.runId,
        healthCategory: input.healthCategory,
        healthReason: input.healthReason,
        error: input.error,
      },
    },
    workflowContext: {
      wakeReason: 'owner_fix_with_ai',
      expectedAction: 'inspect_fix_prepare_same_bot_start_or_update',
      recoveryContractId: DEPLOYMENT_FIX_WITH_AI_CONTRACT_ID,
      promptSha256: DEPLOYMENT_FIX_WITH_AI_PROMPT_SHA256,
    },
  };
}

/** Single repair-contract handoff for Bot Details Fix with AI (UI + Playwright + eval SHA). */
export function buildDeploymentFixWithAiHandoff(input: DeploymentFixWithAiHandoffInput) {
  const recoveryContext = buildDeploymentFixWithAiContext(input);
  return {
    prompt: DEPLOYMENT_FIX_WITH_AI_PROMPT,
    source: DEPLOYMENT_FIX_WITH_AI_SOURCE,
    context: {
      botId: input.botId ?? undefined,
      botName: input.botName ?? undefined,
      deploymentId: input.deploymentId,
      deploymentStatus: input.status,
      runId: input.runId,
      healthReason: input.healthReason,
      healthCategory: input.healthCategory,
      ...recoveryContext,
    },
  };
}
